module.exports = __webpack_public_path__ + "img/bagrova.274734a0.jpg";